import { API_BASE_URL, getHeaders } from './config'

export async function fetchPartner() {
  console.log('fetchPartner called')
  const response = await fetch(`${API_BASE_URL}/partners/me`, {
    headers: getHeaders()
  })
  console.log('fetchPartner response:', response.status)
  
  if (!response.ok) {
    throw new Error('Failed to fetch partner')
  }
  
  return response.json()
}

export async function updatePartner(data: { name?: string }) {
  const response = await fetch(`${API_BASE_URL}/partners/me`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  })
  
  if (!response.ok) {
    throw new Error('Failed to update partner')
  }
  
  return response.json()
}

export async function listAllPartners() {
  const response = await fetch(`${API_BASE_URL}/partners`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to list partners')
  }
  
  return response.json()
}
